.root {
  position: relative;
  width: 120px;
  height: 120px;
  margin-bottom: 2rem;
  color: var(--status-page-ball-color);
  background-color: var(--status-page-ball);
  border-radius: var(--radius-full);

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 60%;
    height: 60%;
    transform: translate(-50%, -50%);
  }
}
